export const DARK_BACKGROUND_COLOR = "#494949";
export const WHITE_COLOR = "#ffffff";
